import { memo } from 'react';

function DoubleLeftIcon({
	className,
	calendar,
}: {
	className?: string;
	calendar?: boolean;
}) {
	if (calendar) {
		return (
			<svg
				width="14"
				height="12"
				viewBox="0 0 14 12"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className={className}
			>
				<path
					d="M11.9297 10.5L7.42969 6L11.9297 1.49999"
					stroke="currentColor"
					strokeWidth="1.64454"
					strokeLinecap="square"
				/>
				<path
					d="M6.5664 10.5L2.06641 6L6.56641 1.49999"
					stroke="currentColor"
					strokeWidth="1.64454"
					strokeLinecap="square"
				/>
			</svg>
		);
	}
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="8"
			height="8"
			viewBox="0 0 8 8"
			fill="none"
			className={className}
		>
			<path
				stroke="currentColor"
				strokeLinecap="square"
				d="M7.002 7.04 4.266 4.302l2.736-2.737M3.736 7.04 1 4.302l2.736-2.737"
			/>
		</svg>
	);
}

export default memo(DoubleLeftIcon);
